module.exports = __webpack_public_path__ + "static/media/hen.830ca20b.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/logo/hen.png
// module id = 959
// module chunks = 0